module.exports = __webpack_public_path__ + "static/media/dashboard3.19796cca.png";